import React from 'react'
import IcoMoon from 'react-icomoon'
const iconSet = require('./selection.json')

const CustomIcon = ({ size = 24, ...props }) => {
  return <IcoMoon iconSet={iconSet} {...props} size={size} />
}

export default CustomIcon
